import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConfigModule, I18nModule} from '@spartacus/core';
import {HomepageErrorComponent} from '@app/homepage/homepage-error/homepage-error.component';
import {GenericConfiguratorErrorModule} from '@app/product/configurator/error-handling/generic-configurator-error/generic-configurator-error.module';

@NgModule({
  declarations: [
    HomepageErrorComponent,
  ],
  imports: [
    CommonModule,
    I18nModule,
    ConfigModule.withConfig({
      cmsComponents: {
        HomepageErrorComponent: {
          component: HomepageErrorComponent
        }
      }
    }),
    GenericConfiguratorErrorModule,
  ],
  exports: [
    HomepageErrorComponent,
  ],
})
export class HomepageErrorModule {
}
